import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function skipFirstPage({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      fill="black"
      className={className}
    >
      <g stroke="none">
        <path d="M2 19.1313C2 19.6836 1.55228 20.1313 1 20.1313C0.447715 20.1313 -3.91405e-08 19.6836 -8.74228e-08 19.1313L-1.66103e-06 1.13133C-1.70932e-06 0.579044 0.447714 0.131329 0.999998 0.131329C1.55228 0.131329 2 0.579044 2 1.13133L2 19.1313Z" />
        <path d="M16.6976 19.829C17.0882 19.4384 17.0882 18.8053 16.6976 18.4148L8.64144 10.3586L17.2929 1.70711C17.6834 1.31658 17.6834 0.683417 17.2929 0.292893C16.9024 -0.0976323 16.2692 -0.0976323 15.8787 0.292892L6.57307 9.5985C6.38261 9.78897 6.28503 10.0371 6.28036 10.2867C6.24566 10.5804 6.34098 10.8865 6.56631 11.1119L15.2834 19.829C15.6739 20.2195 16.3071 20.2195 16.6976 19.829Z" />
      </g>
    </svg>
  );
}

export default skipFirstPage;
